import {useState,useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { useSelector } from 'react-redux';
import { Logo,Container, SubmitButton} from '../styles/style.js';
import { Settings, Profile,ThemeText,Nav,NavHeader,ThemeMode,StyledLink,MenuButton,ExitButton,NavMenu} from '../styles/NavigationStyle.js';

const logoTop = '317.47,16.455 19.75,16.455 19.75,182.455 232.71,182.455';
const logoBottom = '0,269.5 297.72,269.5 297.72,103.5 84.76,103.5';

export default function Navigation(props){
    const [settings,setSettings] = useState(false)
    const navigate = useNavigate();
    const user = useSelector((state) => state.user);
    const [collapsed,setCollapsed] = useState(false);
    const [menu,setMenu] = useState(false);

    useEffect(()=>{
        setCollapsed(window.innerWidth < 830)
        window.addEventListener('resize', ()=>{setCollapsed(window.innerWidth < 830)})
    },[])

    function getInitials(){
        
        if(props.name !== undefined && props.name !== ''){
            let splitName = props.name.split(' ');
            return splitName[0].charAt(0) + splitName[1].charAt(0);
        }else if(user.name !== ''){
            let splitName = user.name.split(' ');
            return splitName[0].charAt(0) + splitName[1].charAt(0);
        }

        return ''
    }

    const signOut = async(e) =>{
        setSettings(false)
        try {
            await Auth.signOut({ global: true }).then(async() =>{
                localStorage.clear();
                sessionStorage.clear();
                navigate('/',{replace:true})
            }).catch(err =>{
                localStorage.clear();
                navigate('/',{replace:true})
            });
        } catch (error) {
            localStorage.clear();
            sessionStorage.clear();
            navigate('/',{replace:true})
        }
    }
    
    return(
        <>
            <NavHeader></NavHeader>
            <Nav>
                <Logo version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" 
                x="0px" y="0px" width="50px" height="50px" viewBox="-4.5 -6.5 326 298" 
                enableBackground="new -4.5 -6.5 326 298">
                    <g>
                        <polyline 
                            fill="none"  
                            strokeWidth="41" 
                            strokeMiterlimit="10" 
                            points={logoTop}/>
                        <polyline 
                            fill="none" 
                            strokeWidth="41" 
                            strokeMiterlimit="10" 
                            points={logoBottom}/>
                    </g>
                </Logo>

                {!collapsed && props.showNavigation && 
                    <>
                        <StyledLink to='/home'>Home</StyledLink>
                        <StyledLink to='/exams'>Exams</StyledLink>
                        <StyledLink to='/scores'>Scores</StyledLink>
                        <StyledLink to='/checkup'>Checkup</StyledLink>
                    </>
                }

                {collapsed && props.showNavigation && 
                    <>
                        {!menu &&
                            <MenuButton onClick={()=>{setMenu(true)}}></MenuButton>
                        }

                        {menu && 
                            <ExitButton onClick={()=>{setMenu(false)}}></ExitButton>
                        }
                    </>
                }                 

                <Profile 
                    className={settings ? 'selected' : ''} 
                    onClick={()=>{setSettings(!settings)}}>
                    {getInitials()}
                </Profile>
            </Nav>

            {menu && props.showNavigation &&
                <NavMenu>
                    <StyledLink to='/home' onClick={()=>{setMenu(false)}}>Home</StyledLink>
                    <StyledLink to='/exams' onClick={()=>{setMenu(false)}}>Exams</StyledLink>
                    <StyledLink to='/scores' onClick={()=>{setMenu(false)}}>Scores</StyledLink>
                    <StyledLink to='/checkup' onClick={()=>{setMenu(false)}}>Checkup</StyledLink>
                </NavMenu>
            }

            {settings &&
                    <Settings>
                        <Container style={{width:'fit-content'}}>
                            <ThemeMode 
                                className={props.theme === 'Dark' ? 'dark' : 'light'} 
                                onClick={props.changeTheme}>
                            </ThemeMode>
                            &nbsp;
                            <ThemeText onClick={props.changeTheme}>
                                {props.theme} Mode
                            </ThemeText>
                        </Container>
                        {props.showNavigation &&
                            <SubmitButton onClick={signOut}>
                                Sign Out
                            </SubmitButton>
                        }
                    </Settings>
                }
        </>
    )
}